import { render, staticRenderFns } from "./AnswerTypeSelector.vue?vue&type=template&id=242946e8&scoped=true"
import script from "./AnswerTypeSelector.vue?vue&type=script&lang=js"
export * from "./AnswerTypeSelector.vue?vue&type=script&lang=js"
import style0 from "./AnswerTypeSelector.vue?vue&type=style&index=0&id=242946e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242946e8",
  null
  
)

export default component.exports